<template>
  <van-radio-group :value="payType" class="payType">
    <van-cell-group v-for="item of showCellGroup" :key="item.type">
      <van-cell clickable @click="select(item.type)">
        <template name="title">
          <div class="pay-title">
            <img class="img-icon" :src="item.icon" width="100%" />
            <p key="pay" v-if="item.showInte"><span>{{ item.text }}</span>( 当前¥: {{ $setInfoDecimal(inte) }} )</p>
            <p key="pay" v-if="!item.showInte">{{ item.text }}</p>
          </div>
        </template>

        <template #right-icon>
          <van-radio :name="item.type" />
        </template>
      </van-cell>
    </van-cell-group>
  </van-radio-group>
</template>
<script>
import { getUserInte } from '@/api/pay'
import { Cell, CellGroup, Radio, RadioGroup } from 'vant'
const cellGroup = [
  {
    type: 1,
    icon: require('@/assets/icon/intePay.png'),
    text: '积分支付',
    showInte: true,
  },
  // {
  //   type: 3,
  //   icon: require('@/assets/icon/wechat.png'),
  //   text: '微信支付',
  // },
  // {
  //   type: 4,
  //   icon: require('@/assets/icon/alipay.png'),
  //   text: '支付宝支付',
  // }
]
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  model: {
    prop: 'payType',
    event: 'changeType'
  },
  props: {
    showCell: {
      type: Array,
      default: () => []
    },
    payType: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showCellGroup () {
      return this.cellGroup.filter(item => this.showCell.includes(item.type))
    }
  },
  data () {
    return {
      cellGroup,
      inte: 0
    }
  },
  methods: {
    select (type) {
      this.$emit('changeType', type)
    },
      async getInt () {
        const result = await getUserInte()
        this.inte = result.data.data.inte

    }
  },
  created() {
    this.getInt()
  },
}
</script>
<style lang="scss" scoped>
.payType {
  margin-bottom: 3rem;
}
.pay-title {
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  p {
    margin-left: 0.2rem;
  }
}

.pay-type {
  margin: 0.7rem 0 1rem 0;
}
</style>
